import { _ep1, _mw0, command } from "../commandBuilder";
import { CreateOAuth2TokenWithIAM$ } from "../schemas/schemas_0";
export class CreateOAuth2TokenWithIAMCommand extends command(_ep1, _mw0, "CreateOAuth2TokenWithIAM", CreateOAuth2TokenWithIAM$) {
}
